var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"app-image",class:_vm.lazyCls,style:(_vm.style),attrs:{"data-src":_vm.lazySrc,"data-srcset":_vm.lazySrcset},on:{"error":function($event){_vm.error = true}}})
}
var staticRenderFns = []

export { render, staticRenderFns }